import { GetPatientBaselineWeight, GetPatientBaselineWeightResponse } from "@/api/dtos";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetPatientBaselineWeightResponse, GetPatientBaselineWeightResponse>) => response?.data?.baselineWeight; 

const getError = (response?: SWRResponse<GetPatientBaselineWeightResponse, GetPatientBaselineWeightResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useBaselineWeightByPatient = (patientId?: number, configuration?: SWRConfiguration<GetPatientBaselineWeightResponse, GetPatientBaselineWeightResponse>) => {
    
    const request = useMemo(() => {
        if(!patientId) {
            return undefined;
        }

        return () => {
            return new GetPatientBaselineWeight({id: patientId});
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useBaselineWeightByPatient;